import currencyIcons from "../constants/currencyIcons";

export default (currency, paidAmount) =>
  `${currency} ${currencyIcons[currency]}${paidAmount.toFixed(2)}`;
